import {TokenCredentials} from '../login/tokencredentials';
import {LocationType} from './location-type';
import {Area} from './area';

export class Location {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    area : Area;
	locationType : LocationType;
	
	barcode : string;
	capacityUsed : number;
	capacityFree : number;
	capacityMax : number;
	loadUsed : number;
	loadFree : number;
	loadMax : number;

    created : Date;
    updated : Date;
}

export class LocationGeneratorData {
    credentials: TokenCredentials;

	userid : number;
    
	area : Area;
	rack: string;

	locationType : LocationType;
	numberOfZones : number;

	tray_start: number;
	tray_end: number;
	tray_step: number;

	level_start: number;
	level_end: number;
	level_step: number;

	capacityMax : number;
	loadMax : number;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location.ts